import React from "react";
import { Marker } from "./Marker.js";
export function SvgMarker({ svg, width = 45, height = 45, ...props }) {
    return (React.createElement(Marker, { ...props, icon: {
            url: `data:image/svg+xml;base64,${window.btoa(svg)}`,
            scaledSize: new google.maps.Size(width, height),
        } }));
}
